// extracted by mini-css-extract-plugin
export var contrastLow = "_29-1";
export var externalLink = "_29-2";
export var externalLinkIcon = "_29-3";
export var link = "_29-0";
export var linkLabel = "_29-4";